// The ids the Cookie Consent Manager integration hangs on. The script tag is ours — PageWrapperServerExtras
// renders it, and only outside the app webview — while the banner is what the CCM itself injects.
// useCCMShown reads both to tell whether a banner is still to come, and the MPH-1137 rules in globals.css
// key on the banner's markup too, so a change to the banner id has to travel to that stylesheet by hand.
export const CCM_SCRIPT_ID = 'cookie-consent-manager';
export const CCM_BANNER_ID = 'iubenda-cs-banner';
